import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

import { AppConfigService } from 'app/app-config.service'

@Component({
  selector: 'app-privacy-policy',
  imports: [],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacyPolicyComponent implements OnInit {
  sanitizer = inject(DomSanitizer)
  private appConfig = inject(AppConfigService).getAppConfig

  trustedHtml = signal<SafeHtml | null>(null)
  ngOnInit() {
    const text = this.appConfig.data.settings?.privacyPolicyText ?? ''
    // Check if empty. We need to strip tags because quill editor adds empty <p> tags
    const stripped = text.replace(/<[^>]+>/g, '').trim()
    if (stripped) {
      this.trustedHtml.set(this.sanitizer.bypassSecurityTrustHtml(text))
    }
  }
}
